import { defineMessage } from 'react-intl';

export const orderI18n = {
  orderRemainingBalancePaidOffline: defineMessage({
    id: 'order.info.order-remaining-balance-paid-offline',
    defaultMessage: 'Remaining balance of {amount} will be paid in-person at {org}'
  })
};
